import {Checkbox} from '@baidu/luffy-comp-checkbox';
export {CheckboxGroup} from '@baidu/luffy-comp-checkbox';
export default Checkbox;
